import {
    StandardEditResponseModel,
    StandardResponseModel,
} from "../pages/shared/models/standard-response-model";
import { CategoryModel } from "../pages/shared/models/CategoryModel";
import axiosInstance from "../router/interceptor";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:4001/bls";

async function getBlogCategories(
    filter?: any,
    limit?: number,
    page?: number,
): Promise<StandardResponseModel<CategoryModel>> {
    try {
        const authorizationHeader = configAuthorizationHeader();

        return axiosInstance
            .get(
                `${API_URL}/blog/categories?page=${page}&limit=${limit}`,
                { ...authorizationHeader },
            )
            .then((response) => {
                return response?.data as StandardResponseModel<CategoryModel>;
            });
    } catch (error) {
        return Promise.reject(error);
    }
}

async function getBlogCategoryById(postId: number, page?: number) {
    try {
        const authorizationHeader = configAuthorizationHeader();
        return axiosInstance.get(
            `${API_URL}/blog/categories/${postId}?${page ? "page=" + page : ""}`,
            authorizationHeader,
        );
    } catch (error) {
        console.error(error);
    }
}

async function createBlogCategory(
    data: CategoryModel,
): Promise<StandardResponseModel<CategoryModel>> {
    try {
        const authorizationHeader = configAuthorizationHeader();
        return axiosInstance
            .post(
                `${API_URL}/blog/categories`,
                data,
                authorizationHeader,
            )
            .then((response) => {
                return response?.data as StandardResponseModel<CategoryModel>;
            });
    } catch (error) {
        return Promise.reject(error);
    }
}

async function editBlogCategory(categoryId: number, data: CategoryModel) {
    try {
        const authorizationHeader = configAuthorizationHeader();
        return axiosInstance
            .put(
                `${API_URL}/blog/categories/${categoryId}`,
                data,
                authorizationHeader,
            )
            .then((response) => response?.data as StandardEditResponseModel);
    } catch (error) {
        console.error(error);

        return {
            acknowledged: false,
            matchedCount: 0,
            modifiedCount: 0,
            upsertedCount: 0,
            upsertedId: 0,
        };
    }
}

async function deleteBlogCategoryById(categoryId: number) {
    try {
        const authorizationHeader = configAuthorizationHeader();
        return axiosInstance.delete(
            `${API_URL}/blog/categories/${categoryId}`,
            authorizationHeader,
        );
    } catch (error) {
        console.error(error);
    }
}

function configAuthorizationHeader() {
    let token = localStorage.getItem("access_token");
    const refreshToken = localStorage.getItem("refresh_token");
    token = token ? token.replaceAll('"', "") : "";
    return {
        headers: {
            Authorization: "Bearer ".concat(token),
            "x-refresh-token": refreshToken,
        },
    };
}

export default {
    getBlogCategories,
    getBlogCategoryById,
    createBlogCategory,
    editBlogCategory,
    deleteBlogCategoryById,
};
